// extracted by mini-css-extract-plugin
export default {"footer":"footer-module--footer--3jlS6"};